import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function decodeBase64Utf8(b64) {
  const fixed = b64.replace(/-/g, "+").replace(/_/g, "/");
  const binary = atob(fixed);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder("utf-8").decode(bytes);
}

// 게이트웨이는 snsToken 을 fragment(#snsToken=)로 넘긴다. 쿼리는 접근 로그에 남으므로 fragment를 먼저 본다.
function takeSnsToken() {
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const fromHash = new URLSearchParams(hash).get("snsToken");
  const fromQuery = new URLSearchParams(window.location.search).get("snsToken");
  const token = fromHash || fromQuery || "";

  if (token) {
    sessionStorage.setItem("snsToken", token);
    const clean = window.location.pathname + window.location.search;
    window.history.replaceState(null, "", clean);
  }
  return token;
}

// 간편회원가입 콜백
export default function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const callBackUrl = localStorage.getItem('callBackUrl');

    try {
      takeSnsToken();
      const search = new URLSearchParams(window.location.search);
      let b64 = search.get("payload") || search.get("data");

      if (!b64 && window.location.hash.includes("?")) {
        const hashQuery = window.location.hash.substring(window.location.hash.indexOf("?"));
        const hash = new URLSearchParams(hashQuery);
        b64 = hash.get("payload") || hash.get("data");
      }

      if (b64) {
        const decoded = decodeBase64Utf8(b64);
        const profile = JSON.parse(decoded);

        // ✅ profile을 임시 저장 (MemberRegist에서 꺼내쓰기)
        localStorage.setItem("socialProfile", JSON.stringify(profile));

        // ✅ 다시 회원가입 페이지로 이동
        navigate(callBackUrl, { state: { fromSocial: true } });
      }
    } catch (e) {
      console.error("소셜 로그인 콜백 파싱 실패:", e);
      navigate(callBackUrl);
    }
  }, [navigate]);

  return <div>소셜 로그인 처리 중...</div>;
}
